import useRequest from './src/useRequest';
import { clearCache } from './src/utils/cache';
export { clearCache };
export default useRequest;
//# sourceMappingURL=index.js.map